export enum V1Languages {
    "EN" = "EN",
    "DE" = "DE"
}